import { georesourceConstants } from '../constants';
import { alertActions } from 'actions';
import { georesourceService } from 'services';
import { global } from 'config';

export const georesourceActions = {
  getCities,
  getCountries,
  getCurrencies,
  getCountryCodes
};

function getCities(cityPrefix, countryPrefix, limit = global.LIMIT, page = global.PAGE) {
  return dispatch => {
    dispatch(request());

    georesourceService.getCities(cityPrefix, countryPrefix, limit, page)
      .then(
        data => dispatch(success(data)))
      .catch(error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
      });
  };

  function request() { return { type: georesourceConstants.GET_CITIES_REQUEST } }
  function success(data) { return { type: georesourceConstants.GET_CITIES_SUCCESS, data } }
  function failure(error) { return { type: georesourceConstants.GET_CITIES_FAILURE, error } }
}

function getCountries(countryPrefix, limit = global.LIMIT, page = global.PAGE) {
  return dispatch => {
    dispatch(request());

    georesourceService.getCountries(countryPrefix, limit, page)
      .then(
        data => dispatch(success(data)))
      .catch(error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
      });
  };

  function request() { return { type: georesourceConstants.GET_COUNTRIES_REQUEST } }
  function success(data) { return { type: georesourceConstants.GET_COUNTRIES_SUCCESS, data } }
  function failure(error) { return { type: georesourceConstants.GET_COUNTRIES_FAILURE, error } }
}

function getCurrencies(currencyPrefix, limit = global.LIMIT, page = global.PAGE) {
  return dispatch => {
    dispatch(request());

    georesourceService.getCurrencies(currencyPrefix, limit, page)
      .then(
        data => dispatch(success(data)))
      .catch(error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
      });
  };

  function request() { return { type: georesourceConstants.GET_CURRENCIES_REQUEST } }
  function success(data) { return { type: georesourceConstants.GET_CURRENCIES_SUCCESS, data } }
  function failure(error) { return { type: georesourceConstants.GET_CURRENCIES_FAILURE, error } }
}

function getCountryCodes(countryPrefix, limit = global.LIMIT, page = global.PAGE) {
  return dispatch => {
    dispatch(request());

    georesourceService.getCountryCodes(countryPrefix, limit, page)
      .then(
        data => dispatch(success(data)))
      .catch(error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
      });
  };

  function request() { return { type: georesourceConstants.GET_COUNTRIES_DIAL_CODES_REQUEST } }
  function success(data) { return { type: georesourceConstants.GET_COUNTRIES_DIAL_CODES_SUCCESS, data } }
  function failure(error) { return { type: georesourceConstants.GET_COUNTRIES_DIAL_CODES_FAILURE, error } }
}
